/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import apiClient from '../apiClient';
import { CashboxesByStoreTypesDto, CashBoxesStatisticsDto } from './statisticsClient.typings';

//TODO remove
function getCashboxesByStoreTypes(): Promise<CashboxesByStoreTypesDto> {
    return apiClient.get('1.0.0/statistics/cashBoxes/byStoreTypes');
}

function getCashBoxesStatistics(): Promise<CashBoxesStatisticsDto> {
    return apiClient.get('1.0.0/statistics/cashBoxes');
}

export const statisticsClient = {
    getCashboxesByStoreTypes,
    getCashBoxesStatistics,
};
